export enum TransactionStatus {
  Invalid = "Invalid",
  Pending = "Pending",
  Completed = "Completed",
  Failed = "Failed",
  Rejected = "Rejected",
  Expired = "Expired",
}

export enum NotificationCode {
  DISPUTE_RAISED = 901,
  MEDIATION_STARTED = 902,
  DISPUTE_READY_RESOLUTION = 903,
  DISPUTE_RESOLVED = 904,
  FINANCIAL_ACTON_TAKEN = 905,
  BOOKING_CREATED = 906,
  SECURITY_DEPOSIT_HOLD = 907,
  DEPOSIT_RELEASED = 908,
  BOOKING_CLOSED = 909,
  WITHDRAWAL_REQUEST_RECIEVED = 910,
  PRODUCT_REVIEWED = 911,
  USER_REVIEWED = 912,
}
